import React from 'react';

export const WebteraIcon = ({ size = 32, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={`inline-block flex-shrink-0 ${className}`}
    >
      <defs>
        <linearGradient id="wBgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0a101d" />
          <stop offset="100%" stopColor="#030712" />
        </linearGradient>
        <linearGradient id="wNeonGrad" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00f2fe" />
          <stop offset="50%" stopColor="#4facfe" />
          <stop offset="100%" stopColor="#00f5a0" />
        </linearGradient>
        <linearGradient id="wSilverGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="50%" stopColor="#94a3b8" />
          <stop offset="100%" stopColor="#334155" />
        </linearGradient>
        <filter id="wGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect width="64" height="64" rx="16" fill="url(#wBgGrad)" />
      <rect width="62" height="62" x="1" y="1" rx="15" fill="none" stroke="#1e293b" strokeWidth="1.5" />

      {/* Left Metallic Stem */}
      <path d="M 12 22 L 18 22 L 25 43 L 19 43 Z" fill="url(#wSilverGrad)" />

      {/* Glowing Trendline */}
      <path
        d="M 23 43 L 32 26 L 39 37 L 49 19"
        fill="none"
        stroke="url(#wNeonGrad)"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#wGlow)"
      />

      {/* Arrow Head */}
      <path
        d="M 42 18 L 51 18 L 51 27"
        fill="none"
        stroke="url(#wNeonGrad)"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#wGlow)"
      />

      {/* Right Wing */}
      <path d="M 40 43 L 46 43 L 52 32 L 47 32 Z" fill="url(#wSilverGrad)" />

      {/* Highlight dot */}
      <circle cx="50" cy="18" r="2" fill="#ffffff" filter="url(#wGlow)" />
    </svg>
  );
};

export const WebteraLogo = ({
  size = 32,
  showText = true,
  subtitle = '',
  isDark = true,
  className = '',
  compact = false
}) => {
  if (compact || !showText) {
    return (
      <div className={`flex items-center ${className}`}>
        <WebteraIcon size={size} />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 select-none ${className}`}>
      <WebteraIcon size={size} />
      <div className="flex flex-col leading-none">
        <span
          className={`font-black tracking-wider text-base sm:text-lg flex items-center ${
            isDark ? 'text-white' : 'text-gray-900'
          }`}
          style={{ fontFamily: "'Inter', 'Poppins', sans-serif" }}
        >
          WEB
          <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-emerald-400 bg-clip-text text-transparent">
            TERA
          </span>
        </span>
        {subtitle && (
          <span className="text-[9px] font-semibold tracking-widest text-cyan-400 uppercase mt-0.5">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};

export default WebteraLogo;
